<template>
  <div class="card border-0" :class="{ shadow: shadow }">
    <img :src="imgUrl" class="cart-img-top" />
    <div class="card-body p-2">
      <h5
        class="card-title mb-3 align-items-center d-flex gap-2"
        v-if="title !== undefined"
      >
        {{ title }}
        <slot name="title-menu"></slot>
      </h5>
      <slot name="body"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "EpiCard",
  props: ["title", "imgUrl", "shadow"],
};
</script>
